function webpackEmptyContext(req) {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
}
webpackEmptyContext.keys = () => ([]);
webpackEmptyContext.resolve = webpackEmptyContext;
webpackEmptyContext.id = "../../node_modules/.pnpm/@sphereon+ssi-sdk.agent-config@0.30.1-unstable.0_sqlite3@5.1.7_ts-node@10.9.2/node_modules/@sphereon/ssi-sdk.agent-config/dist sync recursive";
module.exports = webpackEmptyContext;